import { Helpers } from '../../helpers';
import { IBusinessAssociateType } from '../../interfaces/ibusiness-associate-type';
import { BusinessAssociate } from '../business-associate';

export class BusinessAssociateTypeBase {
  BusinessAssociateTypeId: number;
  Description: string | null;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  BusinessAssociates_BusinessAssociateType?: Array<BusinessAssociate> | null;

  constructor(item?: IBusinessAssociateType) {
    if (item) {

      this.BusinessAssociateTypeId = item.BusinessAssociateTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.BusinessAssociates_BusinessAssociateType = Helpers.createClassArray(BusinessAssociate, item.BusinessAssociates_BusinessAssociateType);
    }
  }
}